import React, { useEffect, useRef, useState } from 'react';
import './Problem.css';

const Problem = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: isMobile ? '0px' : '-150px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const problems = [
    { icon: '/photo/probleme/sablier_sans_fond.png', text: 'Tâches répétitives non automatisées' },
    { icon: '/photo/probleme/cle_mecanique_sans_arriere_plan.png', text: 'Des produits vieillissants sans IA' },
    { icon: '/photo/probleme/personne_travaille_bureaux_sans_arriere_plan.png', text: 'Aucune expertise interne IA' },
    { icon: '/photo/probleme/pile_image_sans_fond.png', text: 'Accès à vos data limité et lent' }
  ];

  return (
    <section id="problem" className={`problem ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="problem-container">
        <h2 className={`section-title fade-in-up ${isVisible ? 'visible' : ''}`}>Les défis que vous rencontrez</h2>
        <div className="problems-grid">
          {problems.map((problem, index) => (
            <div key={index} className={`problem-card scale-in delay-${(index + 1) * 100} ${isVisible ? 'visible' : ''}`}>
              <img src={problem.icon} alt="" className="problem-icon" />
              <p className="problem-text">{problem.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Problem;
